import { theme } from 'lib/theme';
import React from 'react';
import { GestureResponderEvent, Platform, View } from 'react-native';
import { Menu, MenuProps } from './Menu';
import { Pressable, PressableProps } from './Pressable';

export const PressableWithMenu: React.FC<
  PressableProps & {
    menuOptions?: MenuProps['options'] | undefined;
    menuOnPress?: boolean;
    showMenuOnContext?: boolean;
  }
> = (props) => {
  const viewRef = React.useRef<View>(null);

  const [menuPosition, setMenuPosition] = React.useState<
    | {
        x: number | undefined;
        y: number | undefined;
        parentWidth: number | undefined;
        parentHeight: number | undefined;
        parentX: number | undefined;
        parentY: number | undefined;
      }
    | undefined
  >(undefined);

  const isNative = Platform.OS !== 'web';
  const { menuOptions, menuOnPress, onPress, showMenuOnContext = true } = props;

  const handlePress = React.useCallback(
    (event: GestureResponderEvent) => {
      viewRef.current?.measureInWindow((x, y, parentWidth, parentHeight) => {
        setMenuPosition({
          x: isNative ? undefined : event.nativeEvent.pageX,
          y: isNative ? undefined : event.nativeEvent.pageY,
          parentWidth,
          parentHeight,
          parentY: y,
          parentX: x,
        });
      });
    },
    [isNative, viewRef],
  );

  const handleContextPress = React.useCallback((event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setMenuPosition({
      x: event.pageX,
      y: event.pageY,
      parentHeight: undefined,
      parentWidth: undefined,
      parentX: undefined,
      parentY: undefined,
    });
  }, []);

  const handleDismissMenu = React.useCallback(
    () => setMenuPosition(undefined),
    [],
  );

  if (!menuOptions?.length) {
    return <Pressable {...props} />;
  }

  return (
    <Pressable
      {...props}
      onContextPress={showMenuOnContext ? handleContextPress : undefined}
      onPress={onPress || (menuOnPress ? handlePress : undefined)}
      menuElement={
        <View
          ref={viewRef}
          style={{
            position: 'absolute',
            zIndex: 999,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: menuPosition ? theme.colors.blue10 : undefined,
            pointerEvents: 'none',
          }}
        >
          {menuPosition && (
            <Menu
              visible
              options={menuOptions}
              onDismiss={handleDismissMenu}
              marginTop={5}
              x={menuPosition.x}
              y={menuPosition.y}
              parentWidth={menuPosition.parentWidth}
              parentHeight={menuPosition.parentHeight}
              parentX={menuPosition.parentX}
              parentY={menuPosition.parentY}
            />
          )}
        </View>
      }
    />
  );
};
